export const data = {
  experience: [
    {
      id: "01",
      company: "Hova AI",
      web: "http://hova.ai",
      title: "Co-Founder & Software Developer",
      skills: "Flutter, Vue JS & Tailwind CSS",
      description:
        "I currently hold roles as both Co-Founder and Software Developer, contributing to various projects.",
    },
    {
      id: "03",
      company: "Codeland s.r.l",
      web: "http://codeland.it",
      title: "Freelance Frontend Developer",
      skills: "JavaScript, Vue JS & Tailwind CSS",
      description:
        "I breeze through frontend development for the company's client projects with ease.",
    },
    {
      id: "02",
      company: "Andela",
      web: "http://andela.com",
      title: "Technical Team Lead",
      skills: "Leadership, Code Review, React & Node JS",
      description:
        "I've been there since 2021, aiding the younger generation in kickstarting their careers in software development.",
    },

    {
      id: "04",
      company: "Bongalo",
      web: "http://bongalo.com",
      title: "Frontend & Mobile Developer",
      skills: "Nuxt JS, Vue JS & Flutter",
      description:
        "In the period of 2022-2023, I dedicated my efforts to developing diverse internal tools for Bongalo, including both web and mobile applications.",
    },
    {
      id: "05",
      company: "Hepta Analytics",
      web: "http://heptanalytics.com",
      title: "Frontend Developer",
      skills: "Javascript, Vue JS & Vuetify",
      description:
        "Throughout 2021-2022, I contributed to various internal tools at Hepta, including an e-commerce web app.",
    },
  ],
  projects: [
    {
      title: "HovaStore",
      skills: "Flutter, Dart",
      link: "http://hova.ai/",
      image:
        "https://firebasestorage.googleapis.com/v0/b/portifolio-a24d4.appspot.com/o/portifolio%2Fprojects%2Fhovastore.png?alt=media&token=a59f137c-e742-49eb-be86-1b21c6ec64b3",
      description:
        "HOVA AI owns this mobile app designed for SMEs to efficiently oversee and manage their business transactions.",
    },
    {
      title: "Bongalo App",
      skills: "Flutter, Dart",
      link: "http://bongalo.com/",
      image:
        "https://firebasestorage.googleapis.com/v0/b/portifolio-a24d4.appspot.com/o/portifolio%2Fprojects%2Fbongalo.png?alt=media&token=7eb3e0e8-acda-4eb5-9faa-55f47bc3f2ec",
      description:
        "Bongalo offers visitors, travelers, and business people across Africa the simplest and most trustworthy housing solution.",
    },
    {
      title: "Keza Shop",
      description:
        "Hepta Analytics owns an e-commerce web app that integrates a chatbot for engaging interactions with users.",
      skills: "Vue JS, Vuetify & Vuex",
      link: "http://shop.keza.ai/",
      image:
        "https://firebasestorage.googleapis.com/v0/b/portifolio-a24d4.appspot.com/o/portifolio%2Fprojects%2Fkeza.png?alt=media&token=5d10790b-2722-4537-bc4f-c3fe8098ae37",
    },
    {
      title: "Leave Management System",
      description:
        "A web application designed for potential use by various organizations, facilitating the management of employees' leave and the processing of leave requests.",
      skills: "React JS, MUI, Redux & Node Js",
      link: "https://nx-leave-app.netlify.app/",
      image:
        "https://firebasestorage.googleapis.com/v0/b/portifolio-a24d4.appspot.com/o/portifolio%2Fprojects%2Fleave.png?alt=media&token=9841428b-4272-46f1-a494-8cbda5e1eb40",
    },
    {
      title: "Merchandise Online System",
      description:
        "A web application utilized in a factory setting to dynamically oversee and control real-time orders, samples, and production processes.",
      skills: "React JS, MUI, Redux & Node Js",
      link: "https://nx-merchandise.netlify.app/",
      image:
        "https://firebasestorage.googleapis.com/v0/b/portifolio-a24d4.appspot.com/o/portifolio%2Fprojects%2Fmerchandise.png?alt=media&token=d4ce09c7-739f-49fb-812e-3463f66182dc",
    },
    // {
    //   date_updated: "2021-12-06T21:08:28.162Z",
    //   _id: "61ae831dbf6e973438e6d60f",
    //   title: "Phantom",
    //   description:
    //     "Web application to support users for tracking public transport",
    //   languages: "React, Redux, Node JS & PostgreSQL",
    //   link: "https://cabal-frontend-staging.herokuapp.com/,https://github.com/atlp-rwanda/cabal-phantom-backend",
    //   image: "https://cdn-icons-png.flaticon.com/512/1659/1659098.png",
    //   date_created: "2021-12-06T21:39:41.587Z",
    //   __v: 0,
    //   id: "61ae831dbf6e973438e6d60f",
    // },
    // {
    //   date_updated: "2021-12-06T21:08:28.162Z",
    //   _id: "61ae8266bf6e973438e6d60c",
    //   title: "Home",
    //   description:
    //     "Web application to support users for house renting services",
    //   languages: "React, Redux, Node JS & PostgreSQL",
    //   link: "https://home.ncutixavier.xyz/,https://home-backend.onrender.com/api-docs/#/",
    //   image: "https://cdn-icons-png.flaticon.com/512/1659/1659098.png",
    //   date_created: "2021-12-06T21:36:38.758Z",
    //   __v: 0,
    //   id: "61ae8266bf6e973438e6d60c",
    // },
    {
      title: "Expresso API",
      description:
        "This is an API with all routing and database logic for an internal tool for a coffee shop called Expresso",
      skills: "Node JS & SQLite",
      link: "https://expresso-backend.onrender.com/api-docs/",
      image:
        "https://firebasestorage.googleapis.com/v0/b/portifolio-a24d4.appspot.com/o/portifolio%2Fprojects%2Fexpresso.png?alt=media&token=c51a5b2a-52f5-4652-a287-d8874c4bffbf",
    },
    // {
    //   date_updated: "2021-12-06T21:08:28.162Z",
    //   _id: "61ae7ef9bf6e973438e6d605",
    //   title: "Jamming",
    //   description: "Web application that make request on Deezer API",
    //   languages: "React JS",
    //   link: "https://jammming-ncuti.netlify.app/",
    //   image: "https://cdn-icons-png.flaticon.com/512/1659/1659098.png",
    //   date_created: "2021-12-06T21:22:01.230Z",
    //   __v: 0,
    //   id: "61ae7ef9bf6e973438e6d605",
    // },
    {
      title: "Amazon Clone",
      description: "Amazon Landing page clone with React JS",
      skills: "React JS",
      link: "https://amazonclon.netlify.app/",
      image:
        "https://firebasestorage.googleapis.com/v0/b/portifolio-a24d4.appspot.com/o/portifolio%2Fprojects%2Famazon.png?alt=media&token=df1e2289-b57e-4d2c-94a9-d49704d5afff",
    },
    // {
    //   date_updated: "2021-12-06T21:08:28.162Z",
    //   _id: "61ae7c6ebf6e973438e6d5ff",
    //   title: "Messenger",
    //   description: "Landing page of company that provide delivery services",
    //   languages: "HTML, CSS and JavaScript",
    //   link: "https://nx-messenger.netlify.com/",
    //   image: "https://cdn-icons-png.flaticon.com/512/1659/1659098.png",
    //   date_created: "2021-12-06T21:11:10.467Z",
    //   __v: 0,
    //   id: "61ae7c6ebf6e973438e6d5ff",
    // },
    // {
    //   date_updated: "2021-12-06T21:08:28.162Z",
    //   _id: "61ae7c1bbf6e973438e6d5fc",
    //   title: "Volvelab Website",
    //   description: "Company website that shows their services and branding",
    //   languages: "HTML, CSS and JavaScript",
    //   link: "https://volvelab.netlify.app/",
    //   image: "https://cdn-icons-png.flaticon.com/512/1659/1659098.png",
    //   date_created: "2021-12-06T21:09:47.343Z",
    //   __v: 0,
    //   id: "61ae7c1bbf6e973438e6d5fc",
    // },
  ],
  contact: [
    {
      icon: "fa-solid fa-phone",
      label: "Phone",
      link: "tel:+25078357335",
      value: "+250 783 573 335",
    },
    {
      icon: "fa-solid fa-envelope",
      label: "Email",
      link: "mailto:ncuti60@gmail.com",
      value: "ncuti60@gmail.com",
    },
    {
      icon: "fa-solid fa-location-dot",
      label: "Address",
      link: "https://goo.gl/maps/5r2e5eSgPmvfGZiJA",
      value: "KG 10 Ave, Kigali, Rwanda",
    },
  ],
};
